// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"387":"068ae5c2","453":"339f70d0","627":"f1a1531b","766":"b457fa5f","884":"4f1e0c10"}[chunkId] + ".chunk.js";
};